<template>
  <div>
    <div>
      <div v-if="metiers == null || metiers?.length === 0">
        <b-button v-if="HasApiKey" variant="warning" @click="getFromAPI">{{ $t('connector.btn.get_from_api') }}</b-button>
      </div>
      <div v-else>
        <b-button v-b-toggle="'list-invisible-jobs'" class="m-1" variant="info">
          <span class="when-open"><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span>
          <span class="when-closed"><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span>
          {{ $t("connector.label.list_job") }}
        </b-button>
        <b-collapse v-model="listVisible" id="list-invisible-jobs">
          <b-row>

          </b-row>
          <b-table :fields="fields" :items="metiers" small responsive="sm" :tbody-tr-class="rowClass">
            <template #cell(Libelle)="row">
              <b-col>{{ row.item.Libelle }}</b-col>
            </template>
            <template #cell(id)="row">
              <b-col>
                <b-input-group size="sm">
                  <b-form-select id="job" :options="jobs" v-model="row.item.id" @input="updateMetier($event, row.item)">
                  </b-form-select>
                </b-input-group>
              </b-col>
            </template>
            <template #cell(update)="row">
              <b-button v-b-tooltip.hover :title="(row.item.id <= 1) ? '' : $t('connector.tooltip.unused')" size="sm" @click="row.item.id = 0;"
                :disabled="(row.item.id <= 1)" variant="outline-danger">X
              </b-button>

            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { normalizeSync } from "normalize-diacritics";
import { JobsList } from "../../services/global";
import { Jobs } from "../../services/netsoins";
import ApiTitan from "../../services/titan";
import ApiNetsoins from "../../services/proxyNetsoins"

export default {
  name: "ListJobs",
  props: {
    sourceMetiers: {
      type: Array,
      default: null,
    },
    mappedMetiers: {
      type: Array,
      default: null,
    },
    keyapi: {
      type: String,
      default: null
    },
    urlapi: {
      type: String,
      default: null
    },
    config: {
      type: Object,
      default() { return {} },
    },
    connector: {
      type: String,
      default: 'NETSOINS'
    },
    useProxy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: this.$i18n.t('connector.label.list_job'),
      fields: [
        {
          Libelle: {
            label: this.$i18n.t('connector.label.label'),
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          Uri: {
            label: 'URI Partenaire',
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          id: {
            label: this.$i18n.t('connector.label.job'),
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          update: {
            label: this.$i18n.t('label.action'),
            sortable: false,
            tdClass: "align-middle",
          },
        },
      ],
      jobs: null,
      metiers: null,
      listVisible: false,
    };
  },
  watch: {
    sourceMetiers() {
      this.initMetiers();
    },
    useProxy() {
      this.initMetiers();
    },
  },
  async mounted() {
    await this.getjobs();
    this.initMetiers();

  },
  methods: {
    initMetiers() {
      if (this.sourceMetiers) this.setMetiers({ data: this.sourceMetiers });
      else if (this.HasApiKey && this.mappedMetiers?.length > 0) this.getFromAPI();
    },
    async getjobs() {
      this.jobs = await JobsList(true); // Anisen list jobs
      this.jobs.push({ text: "Inutilisé/Indéfini", value: 0 });
    },
    rowClass(item, type) {
      if (this.connector === 'NETSOINS') {
        if (!item || type !== "row") return;
        if (item.id === 1) return "uncompleted";
      } else if (this.connector === 'TITAN') {
        if (item.id <= 1) {
          return "gosted"
        }
      }
    },
    checkJobs(value) {
      // Force la normalisation car différent selon la source
      let vnormalize = normalizeSync(value);
      if (vnormalize === "AS" || vnormalize === "AS stagiaire")
        vnormalize = "Aide soignant(e)";
      else if (vnormalize.toLowerCase().includes("Infirmier".toLowerCase()))
        vnormalize = "Infirmier(ere)";
      else if (vnormalize === "Animateur/trice")
        vnormalize = "Animatrice(eur)";
      const i = this.jobs?.find((j) => {
        if (j.text) {
          const text = normalizeSync(j.text);
          return vnormalize.includes(text);
        }
        return 1;
      });
      if (i) return i.value;
      return 1;
    },
    setMetiers(result) {
      // if (this.jobs === null || this.jobs?.length < 1) {
      //   //console.log('no Job in set metiers');
      //   await this.getjobs();
      // }
      this.metiers = result.data.map((m) => {
        const mapM = this.mappedMetiers?.find((mm) => {
          return mm.ext_id === m.Uri
        }
        )
        const item = {
          Libelle: m.Libelle,
          Uri: m.Uri,
          id: mapM?.id ?? this.checkJobs(m.Libelle),
        };
        this.updateMetier(null, item);
        return item;
      }).sort((a, b) => a.Libelle.toLowerCase().localeCompare(b.Libelle.toLowerCase()));
      this.listVisible = !!this.metiers;
    },
    async getFromAPI() {
      let values = []
      if (this.connector === 'NETSOINS') {
        if (this.useProxy) {
          const api = new ApiNetsoins(this.keyapi, this.urlapi);
          values = await api.getJobs();
        }
        else {
          values = await Jobs({ uri: this.urlapi, key: this.keyapi });
        }
      } else if (this.connector === 'TITAN') {
        const api = new ApiTitan(this.config.apilogin, this.config.apipassword, this.config.apikey, this.config.apiurl, this.config.ext_uri);
        values = (await api.getJobs()).map(j => { return { Libelle: j.name, Uri: 'TITAN://speciality#' + j.id} });
      }
      if (values) {
        this.setMetiers({ data: values });
      }
    },
    updateMetier(_, item) {
      this.$emit("update-metier", item);
    }
  },
  computed: {
    HasApiKey() {
      return (this.keyapi !== null && this.urlapi !== null) ||
        (this.config && this.config.apilogin !== null && this.config.apipassword !== null && this.config.apikey !== null && this.config.apiurl !== null && this.config.ext_uri !== null);
    }
  }
};
</script>
<style>
.deleted {
  font-size: 20px;
  color: rgb(92, 16, 16);
}

.gosted {
  color: grey;
  background-color: lightgray;
}

.uncompleted {
  color: red;
  background-color: rgb(247, 222, 222);
}
</style>
